import { setProps } from '../props';
import fetchEmail from '../Services/fetchEmail';

export default (props) => (dispatch) => {

  setProps(props);
  dispatch(fetchEmail());
  
}